<div class="briefs-wrappers">
  <mat-card appearance="outlined" class="brief-section" *ngIf="!briefKeys.length">
    No briefs have been added
  </mat-card>
  <div class="brief-section" *ngFor="let key of briefKeys">
    <h6 class="brief-header">
      Brief
    </h6>
    <h6>
      <strong>Date:</strong>
      {{briefs[key].briefTimestamp | date:'fullDate'}}
    </h6>
    <h6>
      <strong>Number of Finals:</strong>
      {{briefs[key].numOfFinals ? briefs[key].numOfFinals : 'Number of finals not chosen'}}
    </h6>

    <div class="brief">
      <div class="brief-inner" *ngIf="briefs[key].brief; else noBrief" [innerHTML]="briefs[key].brief">
      </div>
      <ng-template #noBrief>
        <div class="no-brief">No Brief</div>
      </ng-template>
    </div>
  </div>
</div>
